import * as React from 'react';
import { cn } from '@/lib/utils';

type ActionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'ghost' | 'outline';
  size?: 'default' | 'sm' | 'icon';
};

export const ActionButton = React.forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ className, variant = 'primary', size = 'default', ...props }, ref) => {
    const base =
      'inline-flex items-center justify-center rounded-full font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 disabled:opacity-50 disabled:pointer-events-none';
    const sizes = {
      default: 'h-9 px-4 text-sm',
      sm: 'h-8 px-3 text-sm',
      icon: 'h-8 w-8',
    }[size];
    const variants = {
      primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
      ghost: 'bg-transparent text-muted-foreground hover:text-foreground hover:bg-muted',
      outline: 'border border-border bg-transparent text-foreground hover:bg-muted',
    }[variant];
    return (
      <button ref={ref} className={cn(base, sizes, variants, className)} {...props} />
    );
  }
);
ActionButton.displayName = 'ActionButton';


